import { render } from "./index.vue?vue&type=template&id=02335c9e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=02335c9e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=02335c9e&lang=scss"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02335c9e"],['__file',"src/views/navigation/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02335c9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02335c9e', __exports__)) {
    console.log('reload')
    api.reload('02335c9e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=02335c9e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('02335c9e', render)
  })

}


export default __exports__